import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { CheckoutHelperService, Order, Order_Type, OrderService, UserService } from '@carmato/car-market';
import { map } from 'rxjs';
import { ABO_LAST_STEP, LEASING_LAST_STEP } from '../constants';

export const checkoutGuard: CanActivateFn = route => {
  const orderService = inject(OrderService);
  const checkoutHelper = inject(CheckoutHelperService);
  const userService = inject(UserService);
  const router = inject(Router);

  const orderId = route.parent.paramMap.get('orderId');
  const vehicleId = route.parent.paramMap.get('id');
  const currentStep = route.data['step'];

  if (!orderId || !userService.isUserLoggedIn()) {
    router.navigate([`login`]);
    return false;
  }

  return orderService.getOrder(+orderId).pipe(
    map(response => {
      const order = response.payload.order;
      const isLeasing = order.type === 'LEASING';
      const lastStep = isLeasing ? LEASING_LAST_STEP : ABO_LAST_STEP;
      const savedLastStep = order.domain_data.step;

      if (lastStep === savedLastStep + 1 && currentStep < lastStep) {
        return false;
      }

      if (savedLastStep + 1 < currentStep && !skipStep(savedLastStep, currentStep, order.type)) {
        return false;
      }

      if (!budgetCheck(order, isLeasing)) {
        router.navigate([`error/contract/leasing/${orderId}/${vehicleId}`]);
        return false;
      }

      checkoutHelper.setOrder(order);
      return !!order;
    })
  );
};

function budgetCheck(order: Order, isLeasing: boolean): boolean {
  const budgetStep = isLeasing ? 5 : 0;
  if (!budgetStep || order.domain_data.step < budgetStep) return true;

  const budget = order.budget?.budget_rate;
  const leasing = order.leasing;
  const leasingPro = leasing?.services?.[0];
  const total = +leasing.leasing_rate + (leasingPro?.monthlyRateInclVat ?? 0);

  return +budget >= +total;
}

function skipStep(savedLastStep: number, currentStep: number, orderType: Order_Type): boolean {
  const skipSteps = new Map<Order_Type, number[]>([
    ['ABO', [1, 4, 5]],
    ['LEASING', [1, 7, 8]]
  ]).get(orderType);

  return skipSteps.some(skipStep => savedLastStep === skipStep && currentStep === skipStep + 2);
}
